import { data } from '../../svg/AdminPanelSettings/data';
import { makeIcon } from '../makeIcon';

export const AdminPanelSettings = makeIcon(data, 'admin_panel_settings', 'AdminPanelSettings');

export default AdminPanelSettings;
